import React, { Fragment } from 'react';
import Button from "@mui/material/Button";
import { ShoppingCart } from "@mui/icons-material";
import { useShoppingCart } from "../context/ShoppingCartContext";
import { Link } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { Alert } from "@mui/material";

function CartCheckOutButtonFloat(props) {
  const { cartQuantity } = useShoppingCart();
  const { auth } = useAuth();

  return (
    <Fragment>
      {cartQuantity > 0 && !window.location.pathname.includes("/checkout") && !auth?.stop_credit ? (
        <div className="cart-float">
          <Button component={Link} to="/checkout" className="btn-animated" size="large"
            color="success"
            startIcon={<ShoppingCart style={{ color: 'yellow' }} />}
            variant="contained">
            Checkout {cartQuantity} Items
          </Button>
        </div>
      ) : null}
    </Fragment>
  );
}

export default CartCheckOutButtonFloat;